export default "__VITE_ASSET__eb1370ff__"